import gql from "graphql-tag";

//Groups of TREEZ

export const QUERY_TREEZ_HEADLESS_GROUPS = gql`
    query getTreezHeadlessGroups(
        $account_id: String!
        $store_id: String!
        $provider_id: String!
    ) {
        getTreezHeadlessGroups(
            account_id: $account_id
            store_id: $store_id
            provider_id: $provider_id
        ) {
            id
            name
            type
            rules
            in_list
            out_list
            current_flag
            restaurant_id
            syncing
        }
    }
`;

export const QUERY_TREEZ_HEADLESS_GROUPS_PAGE = gql`
    query getTreezHeadlessGroupsPage(
        $account_id: String!
        $store_id: String!
        $provider_id: String!
        $page: Int!
    ) {
        getTreezHeadlessGroupsPage(
            account_id: $account_id
            store_id: $store_id
            provider_id: $provider_id
            page: $page
        ) {
            groups {
                id
                name
                type
                rules
                in_list
                out_list
                current_flag
                restaurant_id
                syncing
            }
            page
            page_elements
            total_elements
            has_next_page
        }
    }
`;
